import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

type UpdateCrossingRequestedDateType = {
  crossingRequestedDate: string;
  folderTypologyId: string;
  folderId: string;
};

const updateCrossingRequestedDateAsync = ({
  folderId,
  folderTypologyId,
  crossingRequestedDate,
}: UpdateCrossingRequestedDateType) =>
  axios.put(`/folder-typologies/${folderTypologyId}/folders/${folderId}/crossing-requested-date`, {
    crossingRequestedDate,
  });

export const useUpdateCrossingRequestedDateAsync = () =>
  useMutation({
    mutationFn: updateCrossingRequestedDateAsync,
  });
